import {Heading} from "./Heading";
import {Gallery} from "./Gallery";
import {Content} from "./Content";
import {Related} from "./Related";
import {ContactOwnerModal} from "./ContactOwnerModal";
import {ContactOwnerLeadModal} from "./ContactOwnerLeadModal";

export type {HeadingProps} from "./Heading";
export type {GalleryProps} from "./Gallery";
export type {ContentProps} from "./Content";
export type {RelatedProps} from "./Related";
export type {ContactOwnerModalProps} from './ContactOwnerModal';
export type {ContactOwnerLeadModalProps} from "./ContactOwnerLeadModal";

export default {
    Heading,
    Gallery,
    Content,
    Related,
    ContactOwnerModal,
    ContactOwnerLeadModal,
};
